import Fullpage from '../utilities/fullpage.js';
import Marquee from '../utilities/marquee';

export default function homeProjectsSection(context) {

  // Get project sections
  let projectSections = context.querySelectorAll("#project-sections section");
  if (!projectSections.length) return;

  // Title animator
  let titleMarquee = new Marquee('#projects-marquee', [...projectSections].map(item => {
    return item.dataset.title;
  }));

  // First backgroud color
  let section = context.querySelector('#project-sections section');
  document.body.style.backgroundColor = section.dataset.bgcolor;

  // Full page for context
  window.fullPage = Fullpage('#project-sections', [], {
    onLeave: (origin, destination, direction) => {
      let section = context.querySelector(`[data-anchor='${destination.anchor}']`);

      // Don't allow scroll down if menu is open
      if (window.menu.isOpen && direction === 'down') return false;

      // Scroll out of menu
      if (!origin.isLast) {
        let noScroll = window.menu.isOpen;
        window.menu.close(); if (noScroll) return false;
      }
      if (!origin.isLast && window.menu.isOpen) return false;
      
      // If last 'psudeo' section
      if (destination.isLast) {

        // Open menu
        window.menu.open();

        // Timeout to scrollback to 
        setTimeout(() => {
          window.fullPage.silentMoveTo(origin.anchor);
        }, 700);
      } else {
        
        // Set marquee text
        if (section) titleMarquee.goto(section.dataset.title);

        // Close menu
        if (!origin.isLast) window.menu.close();
      }

      // Background color
      document.body.style.backgroundColor = section.dataset.bgcolor;
    }
  });

  // Click on an image, create a dummy overlay version for fade out (so it doesn't fade out and back in again)
  let projectLinks = document.querySelectorAll('.project-link');
  if (projectLinks) projectLinks.forEach(link => {
    link.addEventListener('click', event => {
      let image = link.querySelector('img');
      if (image) {
        let cover = image.cloneNode();
        cover.style.position = 'absolute';
        cover.style.top = `${image.getBoundingClientRect().top}px`;
        cover.style.left = `${image.getBoundingClientRect().left}px`;
        cover.style.width = `${image.clientWidth}px`;
        cover.style.height = `${image.clientHeight}px`;
        cover.id = 'transitionCoverImage';
        document.body.append(cover);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./source/javascript/sections/home-projects.js